export default __webpack_public_path__ + "static/media/PandenzaLand_BG_Square_4k.2c273e4e.jpg";